import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import classNames from "classnames";

import Head from "next/head";

// core components
import Header from "components/Header/Header";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Footer from "components/Footer/Footer.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import { Link } from "@material-ui/core";
import styles from "assets/jss/nextjs-material-kit/pages/landingPage.js";
import customStyles from "assets/jss/custom/customStyles.js";
import address from "assets/img/legal/imprintAddress.png";
import contact from "assets/img/legal/imprintContact.png";

const useStyles = makeStyles({
  ...styles,
  ...customStyles,
});

export async function getStaticProps() {
  return {
    props: {},
  };
}

export default function ContentPage(props) {
  const dashboardRoutes = [];
  const { ...rest } = props;
  const classes = useStyles();

  const params = {
    title: "Impressum",
    teaser: "",
  };

  return (
    <div>
      <Head>
        <title>{params.title} | getasugar - das Sugar Dating Portal</title>
        <meta name="description" content={params.teaser} />
        <meta name="robots" content="noindex" />
      </Head>
      <Header
        color="primary"
        routes={dashboardRoutes}
        rightLinks={<HeaderLinks />}
        fixed
        {...rest}
      />
      <div className={classes.main} style={{ marginTop: "3em" }}>
        <div className={classes.row}>
          <div className={classes.container}>
            <div className={classNames(classes.hasPaddingTop)}>
              <GridContainer
                justify="center"
                className={classNames(
                  classes.hasPaddingTop,
                  classes.contentContainer,
                  classes.hasShadow
                )}
              >
                <GridItem xs={12}>
                  <h2 className={classes.h2}>{params.title}</h2>
                </GridItem>

                <GridItem xs={12}>
                  <p>getasugar.de ist ein Service der</p>
                  <p>
                    <img src={address.src} alt="Adresse" width="393" />
                  </p>
                  <p>
                    Sitz der Gesellschaft: Hamburg
                    <br />
                    Amtsgericht Hamburg, HRB 178854
                    <br />
                    USt - IdNr: DE360485626
                    <br />
                  </p>

                  <p>
                    E-Mail:{" "}
                    <Link href="mailto:support@getasugar.de">
                      support@getasugar.de
                    </Link>{" "}
                    <br />
                    Telefon: +49 40 / 33 46 46 26 <br />
                  </p>
                </GridItem>
                <GridItem xs={12}>
                  <h3>
                    Alternative Streitschlichtung (Art. 14 Abs. 1 ODR-VO):
                  </h3>
                  <p>
                    Die Internetplattform der Europäischen Union zur
                    Online-Streitbeilegung (sog. "OS-Plattform") ist unter dem
                    folgenden Link erreichbar: 
                    <Link href="http://ec.europa.eu/consumers/odr/">
                      http://ec.europa.eu/consumers/odr/
                    </Link>
                  </p>
                  <p>
                    lovely vibes GmbH weist darauf hin, dass sie nicht bereit
                    und nicht verpflichtet ist, an Streitbeilegungsverfahren vor
                    einer Verbraucherschlichtungsstelle teilzunehmen.
                  </p>
                </GridItem>
                <GridItem xs={12}>
                  <h3>Haftungshinweis: </h3>
                  <p>
                    Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir
                    keine Haftung für die Inhalte externer Links. Für den Inhalt
                    verlinkter Seiten sind ausschließlich deren Betreiber
                    verantwortlich.
                  </p>
                </GridItem>
                <GridItem xs={12}>
                  <h3>Verantwortlicher im Sinne von § 18 Abs. 2 MStV: </h3>
                  <p>
                    <img src={contact.src} alt="Kontakt" width="116" />
                  </p>
                </GridItem>
              </GridContainer>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
